<!-- =========================================================================================
   Autor: Martin Vicencio
========================================================================================== -->


<template>
    <div id="invoice-page">
        <vx-card>
             <!-- INVOICE METADATA -->
       <!-- {{total_cuatrimestres_alumno}} -->
       <!-- verifica si esta activo el alumno -->
       <!-- {{status_alumno}} -->

    <div v-if="total_cuatrimestres_alumno <= 14 &&  status_alumno==1">
      <!-- <div v-if="20==20"> -->
           
        <div class="vx-row leading-loose p-base">

                <div class="vx-col w-full md:w-1/2 mt-base">
                    <!-- <img src="../../assets/images/logo/logo.png" alt="vuesax-logo"> -->
                    <!-- logo -->
                </div>
                <div class="vx-col w-full text-right col-sm">
                    <h1>RE-INSCRIPCIÓN DE ALUMNO </h1>
                    <div class="invoice__invoice-detail mt-6">
                        <h6>
                  
                          Nombre: 
                                 <br> <b>{{alumno_detalle2['ncompleto']}} </b>  <br>
                            Matrícula: 
                                  <br> <b>{{matricula}} </b> <br>
                            Periodo a inscribirse: <br>
                                   <b>{{cuatrimestre_siguiente[0].nombre}} {{cuatrimestre_siguiente[0].idAgno}} </b>       
                        </h6>
                    </div>
                </div>

                <div class="vx-col w-full mt-12" v-if="abrir_inscripcion >= 1 && abrir_inscripcion_si_paso_materias == 0" >

                            <!-- <div class="vx-col w-full mt-12" v-if="abrir_inscripcion >= 0">  -->
                             <!-- el cero es para modo de pruenas que me deje abierto el periodo--> 
                    <br>

                     <!-- se comento la referencia solo para separar de el modulo de reincripcion y carga de materias momentanio pendientes
                      de prograMAR SU REACTIVACION EN BASE A FECHAS EN SAE -->

<!-- <div class="container"> -->
  <div class="row">
        <!-- <div class="col-6"> -->
          <div class="col-sm">

          <span class="alert alert-info" style="padding: 7px;  margin: 5px;" v-show="renovar_seguro==2"> Tu Seguro esta Vigente!</span><br>
          <!-- <span style="text-align: right;">nota</span>  -->

        </div>
    <!-- <div class="col-3">  -->
      <div class="col-sm">
           <!-- <div v-show="cantidad_aspirantes_fecha>1" class="alert alert-info" role="alert"> Total de aspirantes: <b>{{cantidad_aspirantes_fecha}}  </b> </div> -->
       <vs-button :disabled="renovar_seguro==2 || fecha_caduca_validacion >= fecha_actual_bloqueo_temporal_asta_paso_dia_caducidad_por_validacion " style="padding: 10px; border: 2px solid #4CAF50;  margin: 5px;"
        title="Nota: antes de generar la referencia de reinscripción, primero debes de generar la de Aportación anual para Seguro de Gastos Médicos Contra Accidentes para los Alumnos"
        class="float-right"  @click="genera_referencia_seguro()">
                  Generar Nueva Referencia Bancaria de Seguro de Gastos Médicos
       </vs-button>
                  <!-- {{fecha_caduca_validacion}} -->
    
    </div>
     <!-- <div class="col-3"> -->
      <div class="col-sm">
      <!-- :disabled=""   :disabled="hay_referencia_seguro == 0 || = O " -->
      <div v-if="hay_referencia_seguro == 1 || renovar_seguro==2">
    <vs-button :disabled="referencias_pagada_boton_desabilitar == 1 || fecha_caduca_validacion_reinscripcion >= fecha_actual_bloqueo_temporal_asta_paso_dia_caducidad_por_validacion" style="padding: 24px; border: 2px solid #4CAF50; margin: 5px; " title="Reinscripción a licenciatura cuatrimestral" class="float-right"  @click="genera_referencia()">
      {{txt_btn}}</vs-button>
      <!-- {{fecha_caduca_validacion_reinscripcion}}  -->
   </div>
    </div>
  </div>

<!-- </div> -->
                    
   <br>

<!-- PENDIENTE -->
    <div class="flex-centered" v-if="hay_referencia_seguro == 1 || hay_referencia == 1 ">
        
               Tu referencia se ha generado correctamente, Descarga el archivo de referencia de pago.
     </div>
        <div class="flex-centered" v-if="hay_referencia_seguro == 1">
          <!-- colocar un if para mostrar solo cuando se genere la referencia  -->
               <!-- Tu referencia se ha generado correctamente, Descarga el archivo de referencia de pago. -->
             <vs-table stripe :data="referencias_seguro" 
             title="Nota: el sistema habilitara el botón de carga de materias, hasta que detecte los dos pagos el seguro y de reinscripción.">

               <template slot="thead">
                 <vs-th></vs-th>
                  <vs-th>Estatus</vs-th>
                </template>

               <template slot-scope="{data}">
                 <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                 
                   <vs-td  v-if="data[indextr].pagado == 0"  :data="data[indextr].id">
                     <vs-button  color="danger"  @click="ver_pdf(data[indextr].idref)"  >Descargar archivo de Referencia de Seguro de Gastos Médicos  (PDF) </vs-button>
                 

                 <span v-show="0"> 
                      Caducidad de referencia: {{fecha_caduca_validacion=data[indextr].fechaCaducidad}}  

                </span>      
                   
                  <!-- Caducidad de referencia: {{fecha_caduca_validacion=data[indextr].fechaCaducidad}}     -->

  <!-- <vs-button  color="danger" style="margin: 2px 2px;"  @click="ver_rubrica()">Descargar Rúbrica de Evaluaciones en (PDF)</vs-button> -->

                   </vs-td>
                   
                   <vs-td v-if="data[indextr].pagado == 1" :data="data[indextr].id" colspan="2">
              
                 <div class="alert alert-success" role="alert">
    <b> "Referencia de Seguro Pagada"</b>
</div>
                  <!-- , ya puedes realizar tu carga de materias. <a href="/alumnos/cargadematerias/" target="" rel="noopener noreferrer">da clic aquí.</a> -->
                  </vs-td>
                  <vs-td v-else :data="data[indextr].id">

       <div v-if="data[indextr].pagado==1">
                       <div class="alert alert-success" role="alert">
         <b> "Referencia de Seguro Pagada"</b></div>

                    </div><div v-else>
                   
                   <div class="alert alert-danger" role="alert">
                     Pendiente de pagar
                         </div>
                </div>
                  </vs-td>
                    </vs-tr>
                </template>
              </vs-table>

              <!-- Una vez realizado el pago tardara hasta 24 horas en acreditarse, y en habilitarse el módulo de carga de materias. -->
          </div>

      <div class="flex-centered" v-if="hay_referencia==1">
       
               <!-- Tu referencia se ha generado correctamente, Descarga el archivo de referencia de pago. -->
             <vs-table stripe :data="referencias">

               <template slot="thead">
                 <vs-th></vs-th>
                  <vs-th>Estatus</vs-th>
                </template>

               <template slot-scope="{data}">
                 <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                 
                   <vs-td  v-if="data[indextr].pagado == 0"  :data="data[indextr].id">
                     <vs-button color="danger"  @click="ver_pdf(data[indextr].idref)"  >Descargar archivo de Referencia de Reinscripcion(PDF)</vs-button>
                     
                 <span v-show="0"> 
                      Caducidad de referencia: {{fecha_caduca_validacion_reinscripcion=data[indextr].fechaCaducidad}}  

                </span>     
                   </vs-td>
                   <!-- 1 pendientes -->
          <vs-td v-if="data[indextr].pagado == 1 &&  renovar_seguro == 2" :data="data[indextr].id" colspan="2">
         <div class="alert alert-success" role="alert">
         <b> "Referencia de Re-inscripcion Pagada"</b></div>
          <b style="font-size: 18px;" >YA PUEDES REALIZAR TU CARGA DE MATERIAS PARA EL NUEVO CUATRIMESTRE</b>
          <br>
           <a href="/alumnos/cargadematerias/" target="" rel="noopener noreferrer"> 
           <!-- style="padding: 10px; border: 2px solid #4CAF50;  margin: 5px;" -->
         <vs-button  class="vs-button vs-button-success vs-button-filled float-center col-sm" style="margin: 4px 4px; padding: 30px; font-size: 18px; font-weight: bold;" >  Dar clic aquí. </vs-button>
         </a>
          </vs-td>
                  <vs-td v-else :data="data[indextr].id">
                  
                    <div v-if="data[indextr].pagado==1">
                       <div class="alert alert-success" role="alert">
         <b> "Referencia de Re-inscripcion Pagada"</b></div>

                    </div><div v-else>
                 <div class="alert alert-danger" role="alert">
                     Pendiente de pagar
                         </div>

                    </div>

                    <!-- {{data[indextr].pagado}}
Pendiente de pago -->
                  </vs-td>               

                    </vs-tr>
                </template>
              </vs-table>
            <!-- 
                 <br>         
          <div>
      <a href="/alumnos/cargadematerias/" target="" rel="noopener noreferrer"> 
         <vs-button  class="vs-button vs-button-success vs-button-filled float-center" style="margin: 2px 2px;" >  Da clic aquí. </vs-button>
         </a>
          </div> -->

<!-- qui estaba la nota de 24 hrs -->
             </div>

          <br>         
          <br><b>
              Nota Importante: <br>
              Recuerda  primero dar clic en generar nueva referencia bancaria del seguro para poder habilitar la referencia bancaria de re-inscripcion. <br>
              Una vez realizado los pagos correspondientes se tardará hasta 24 horas hábiles(L - V) en habilitarse y acreditarse  el módulo de carga de materias. <br>
              Una vez que hayas realizado y guardado la carga de materias, no podra editarse hasta la fecha de descarga de materias (quitar materias), <a href="/alumnos/calendarioescolar/" target="_blank" rel="noopener noreferrer">
              ver Calendario Escolar.</a> 

              <br>
             </b>

              </div>
                <div v-else>
                    <h2>Aun no inicia el periodo de Re-inscripción, <a href="/alumnos/calendarioescolar/" target="_blank" rel="noopener noreferrer">ver Calendario Escolar.</a>  </h2>
                
                  <div v-if="abrir_inscripcion_si_paso_materias >0">
                    <h3> <mark>¡Aun no has aprobado todas tus materias!, el sistema te permitirá cargar, a partir de que pase el periodo de captura de extraordinarios.</mark></h3>              
                  </div>

                </div>      

          </div>
    </div>
   <div v-else>
                    <h2>Has superado el límite de periodos para cursar tus estudios universitarios y/o tu estatus académico es inactivo.</h2> <br>
                    <h3>Acudir con tu Dirección de carrera.</h3> 
                
  </div>


        </vx-card>
    </div>
</template>

<script>
import Dialogs from '../components/vuesax/dialogs/Dialogs.vue';

export default{
    data() {
        return {
          fecha_caduca_validacion:'',
          fecha_caduca_validacion_reinscripcion:'',
          // MyDate: new Date(),
          // MyDateString: new Date(),
          // mi: new Date().setDate(new Date().getDate()+10),
          // mi:('0' + new Date().getDate()).slice(-2) + '-' + ('0' + (new Date().getMonth()+1)).slice(-2) + '-' + new Date().getFullYear(),
          
 fecha_actual_bloqueo_temporal_asta_paso_dia_caducidad_por_validacion:new Date().getFullYear()+'-' + ('0' + (new Date().getMonth()+1)).slice(-2) +'-'+ ('0' + new Date().getDate()).slice(-2),

               // mi: new Date().getDate() + '-' + (new Date().getMonth()+1) + '-' + new Date().getFullYear(),
                // fecha_hoy:   new Date().toISOString(),
                // fecha_hoy_agno:   new Date().toLocaleDateString(),
                //  fecha_hoy_agno:  new Date().getFullYear('en-us'),
                // fecha_hoy_mes:  new Date().getMonth('en-us'),
                // fecha_hoy_dia:  new Date().getDay('en-us'),

              // fecha_hoy_agno: new Date().toLocaleDateString('en-us', { year:"numeric"}),
              // fecha_hoy_mes:   new Date().toLocaleDateString('en-us', { month:"numeric"}),
              // fecha_hoy_dia:   new Date().toLocaleDateString('en-us', { day :"numeric"}),
              // fecha_actual_bloqueo_temporal_asta_paso_dia_caducidad_por_validacion: {},
           
            matricula: localStorage.getItem('matricula'),
            status_alumno: localStorage.getItem('status_alumno'),
            id: localStorage.getItem('id'),
            // verifica: false,
            year_act: new Date().getFullYear(),
            referencia: '',
            txt_btn: 'Generar Nueva Referencia Bancaria de Reinscripción',
            cuatrimestre_siguiente: [{ nombre: "", idAgno: "" }],
            abrir_inscripcion:{},
            total_cuatrimestres_alumno:0,
            abrir_inscripcion_si_paso_materias:{},
            cuatri:null,
            talla:null,
            hay_referencia:'',
            cuatrimestreAlumno:{},
            referencias:[],
            referencias_seguro:[],
            hay_referencia_seguro:'',
            alumno_detalle2: [],
            si_pago_seguro:'',
            // vigencia_seguro:'',
            renovar_seguro: '',
            referencias_pagada_boton_desabilitar:''
        
        }
    },
    computed: {

    },
    created() {
        // this.verifica_referencia();
         this.getAlumno();
         this.getCuatrimestreSiguiente();
         this.open_inscripcion();
          this.get_total_cuatrimestres_alumno();
         this.open_inscripcion_si_paso_materias();
         this.cuatrimestre_actual_alumno();
    


    },
    mounted() {
    //estaba abilitada el get referecnias antes de que las mandara atraer en el getcuatrimestre actual para el periodo y el año
    // this.getReferencias();
     
  },
    methods: {

      getAlumno() {
            this.$http.get("alumno_id/" + this.id).then(
                response => {
                    this.alumno_detalle2 = response.data.alumno;
                },
                error => { this.StepError(error); }
            );
        },



       cuatrimestre_actual_alumno(){
             this.$http.get("cuatrimestre_actual_alumno/"+this.id).then(
                response => {
                  this.cuatrimestreAlumno = response.data.cuatrimestre_act_alumno;
                //   console.log(this.cuatrimestreAlumno.length);
                // this.open_inscripcion_si_paso_materias();
                },
                error => {
                  this.StepError(error);
                }
            );
          },

        open_inscripcion(){
            this.$http.get("abrir_inscripcion").then(
                response => {
                  this.abrir_inscripcion = response.data;
                  // console.log(this.abrir_inscripcion);
                },
                error => {
                  this.StepError(error);
                }
            );
          },


         get_total_cuatrimestres_alumno(){
            this.$http.get("get_total_cuatrimestres_alumno/"+this.id).then(
                response => {
                  this.total_cuatrimestres_alumno = response.data;
                  // console.log(this.abrir_inscripcion);
                },
                error => {
                  this.StepError(error);
                }
            );
          },
        open_inscripcion_si_paso_materias(){
            this.$http.get("abrir_inscripcion_paso_materias/"+this.id+"/"+this.year_act).then(
                response => {
                  this.abrir_inscripcion_si_paso_materias = response.data;
                  // console.log(this.abrir_inscripcion_si_paso_materias);
                },
                error => {
                  this.StepError(error);
                }
            );
          },

            getCuatrimestreSiguiente(){
            this.$http.get("cuatrimestre_siguiente").then(
                response => {
                  this.cuatrimestre_siguiente = response.data.cuatrimestre_siguiente;
                  this.getReferencias();   //coloque el getreferencias para que trajera las del periodo y año del cuatrimestre actual
                   this.getReferencias_seguro();
                },
                error => {
                  this.StepError(error);
                }
            );
          },

        genera_referencia(){

      let text ="Confirma de Generar Nueva Referencia Bancaria de Reinscripción a Licenciatura cuatrimestral!";
    if(confirm(text) == true){

      this.cuatri=this.cuatrimestreAlumno.length + 1;
      this.$http.get("guardar_referencia_bancomer_reinscripcion/" + this.id + "/" + 1 + "/" + 1 + "/" + this.cuatri+"/"+this.cuatrimestre_siguiente[0].idAgno+"/"+this.cuatrimestre_siguiente[0].idPeriodo).then(
          response => {

           alert("Referencia creada con Exito!");
            this.getReferencias();
          },
           error => {
              this.StepError(error);
           }
         );

        }else {
           text = "Operación Cancelada!";
          }


     },

    genera_referencia_seguro(){

      let text ="Confirma de Generar Nueva Referencia Bancaria para Seguro de Gastos Médicos!";
    if(confirm(text) == true){

      this.cuatri=this.cuatrimestreAlumno.length + 1;
      this.$http.get("guardar_referencia_bancomer_seguro/"+this.id+"/"+this.cuatri+"/"+this.cuatrimestre_siguiente[0].idAgno+"/"+this.cuatrimestre_siguiente[0].idPeriodo).then(
          response => {
           alert("Referencia creada con Exito!");
            this.getReferencias_seguro();
          },
           error => {
              this.StepError(error);
           }
         );

        }else {
           text = "Operación Cancelada!";
          }


     },


     
  getReferencias() {
    // console.log(this.cuatrimestre_siguiente[0].idPeriodo);
      this.$http.get("get_referencias_bancomer_reinscripcion/" + this.id+"/"+this.cuatrimestre_siguiente[0].idAgno+"/"+this.cuatrimestre_siguiente[0].idPeriodo).then(
          response => {
            // console.log(referencias.data)
            this.referencias = response.data.ult_referencia_reinscripcion;
            this.referencias_pagada_boton_desabilitar = this.referencias[0].pagado;


            // console.log(this.referencias_pagada_boton_desabilitar);
             this.hay_referencia=this.referencias.length;   //cuenta si  trae alguna referencia
          },
          error => {
            this.StepError(error);
          }
      );
    },



     
  getReferencias_seguro() {
    // console.log(this.cuatrimestre_siguiente[0].idPeriodo);
      this.$http.get("get_referencias_bancomer_seguro/" + this.id+"/"+this.cuatrimestre_siguiente[0].idAgno+"/"+this.cuatrimestre_siguiente[0].idPeriodo).then(
          response => {
            // console.log(referencias.data)
            this.referencias_seguro = response.data.ult_referencia_seguro;
            this.si_pago_seguro= response.data.ult_referencia_seguro['pagado'];
              // console.log(this.si_pago_seguro);
                  // this.vigencia_seguro= response.data.ult_referencia_seguro[0].vigencia;
                  this.renovar_seguro = response.data.renovar_seguro;
            // console.log(this.vigencia_seguro);
            //  console.log(this.renovar_seguro);
             this.hay_referencia_seguro=this.referencias_seguro.length;   //cuenta si  trae alguna referencia
          },
          error => {
            this.StepError(error);
          }
      );
    },




ver_pdf(id){

     window.open('https://cdn.upbicentenario.edu.mx/api/pdf_referencia_bancomer/' + id) //para que se pueda descargar en telefonos celulares se le quita el weindows. y solo se usa open
      //window.open('http://127.0.0.1:8000/api/pdf_referencia_bancomer/' + id)  
    
    },


        // verifica_referencia() {
        //     this.$http.get("verifica_referencia_finanzas/" + this.id).then(
        //         response => {
        //             if(response.data){
        //                 this.referencia = response.data
        //                 this.verifica = true
        //             }


        //         },
        //         error => {
        //             this.StepError(error);
        //         }
        //     );
        // },

    },

    components: {}
}
</script>

        Dialogs